// extracted by css-extract-rspack-plugin
export default {"nodeRoot":"P66jH","link":"ZJJc_","button":"j_R0z","selected":"UTVJ2","dropTarget":"qnivX","draggable":"HBMdM","dragIcon":"Ma4Hn","dragging":"TKJ1t"};